import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { User, Settings, Bell, Keyboard, Link as LinkIcon, ArrowLeft } from 'lucide-react';
export function AccountProfilePage() {
  return <div className="min-h-screen bg-background" data-id="element-5439">
      <header className="h-16 border-b border-border flex items-center px-6 bg-surface" data-id="element-5440">
        <Link to="/app" className="flex items-center gap-2 text-textMuted hover:text-textMain transition-colors text-sm font-medium" data-id="element-5441">
          <ArrowLeft className="w-4 h-4" data-id="element-5442" /> Back to App
        </Link>
      </header>

      <div className="max-w-5xl mx-auto py-10 px-6 flex flex-col md:flex-row gap-10" data-id="element-5443">
        {/* Sidebar */}
        <div className="w-full md:w-64 shrink-0" data-id="element-5444">
          <h1 className="text-2xl font-bold mb-6" data-id="element-5445">Account</h1>
          <nav className="space-y-1" data-id="element-5446">
            <Link to="/account/profile" className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg bg-primary/10 text-primary font-medium text-sm transition-colors" data-id="element-5447">
              <User className="w-4 h-4" data-id="element-5448" /> Profile
            </Link>
            <Link to="/account/preferences" className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-5449">
              <Settings className="w-4 h-4" data-id="element-5450" /> Preferences
            </Link>
            <button className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-5451">
              <Bell className="w-4 h-4" data-id="element-5452" /> Notification Preferences
            </button>
            <button className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-5453">
              <Keyboard className="w-4 h-4" data-id="element-5454" /> Keyboard Shortcuts
            </button>
            <button className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm" data-id="element-5455">
              <LinkIcon className="w-4 h-4" data-id="element-5456" /> Linked Accounts
            </button>
          </nav>
        </div>

        {/* Main Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex-1" data-id="element-5457">
          <div className="bg-surface border border-border rounded-xl p-8" data-id="element-5458">
            <h2 className="text-lg font-semibold mb-6 border-b border-border pb-4" data-id="element-5459">
              Personal Profile
            </h2>

            <div className="space-y-8" data-id="element-5460">
              {/* Avatar */}
              <div className="flex items-center gap-6" data-id="element-5461">
                <div className="w-20 h-20 rounded-full bg-primary/20 border-2 border-primary flex items-center justify-center text-2xl font-bold text-primary" data-id="element-5462">
                  M
                </div>
                <div data-id="element-5463">
                  <button className="px-4 py-2 bg-background border border-border rounded-lg text-sm font-medium hover:bg-surfaceHover transition-colors mb-2" data-id="element-5464">
                    Change avatar
                  </button>
                  <p className="text-xs text-textMuted" data-id="element-5465">
                    JPG, GIF or PNG. Max size of 2MB.
                  </p>
                </div>
              </div>

              {/* Form */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5466">
                <div data-id="element-5467">
                  <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5468">
                    First Name
                  </label>
                  <input type="text" defaultValue="Mark" className="w-full px-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors" data-id="element-5469" />
                </div>
                <div data-id="element-5470">
                  <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5471">
                    Last Name
                  </label>
                  <input type="text" defaultValue="Johnson" className="w-full px-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors" data-id="element-5472" />
                </div>
                <div className="md:col-span-2" data-id="element-5473">
                  <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5474">
                    Email Address
                  </label>
                  <input type="email" defaultValue="mark@thewildwoodsband.com" className="w-full px-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors" data-id="element-5475" />
                </div>
                <div data-id="element-5476">
                  <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5477">
                    Primary Role
                  </label>
                  <select className="w-full px-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors appearance-none text-textMain" data-id="element-5478">
                    <option data-id="element-5479">Artist / Band Member</option>
                    <option data-id="element-5480">Manager</option>
                    <option data-id="element-5481">Agent</option>
                    <option data-id="element-5482">Venue Buyer</option>
                  </select>
                </div>
                <div data-id="element-5483">
                  <label className="block text-sm font-medium text-textMuted mb-1.5" data-id="element-5484">
                    Timezone
                  </label>
                  <select className="w-full px-4 py-2.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary transition-colors appearance-none text-textMain" data-id="element-5485">
                    <option data-id="element-5486">Central Time (US & Canada)</option>
                    <option data-id="element-5487">Eastern Time (US & Canada)</option>
                    <option data-id="element-5488">Pacific Time (US & Canada)</option>
                  </select>
                </div>
              </div>

              <div className="pt-6 border-t border-border flex justify-end" data-id="element-5489">
                <button className="px-6 py-2.5 bg-primary text-background rounded-lg font-medium hover:bg-primaryHover transition-colors text-sm shadow-[0_0_15px_rgba(245,158,11,0.2)]" data-id="element-5490">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}